import { render, staticRenderFns } from "./PersonnelRecordDeadlinesDataTable.vue?vue&type=template&id=08e07e18"
import script from "./PersonnelRecordDeadlinesDataTable.vue?vue&type=script&lang=js"
export * from "./PersonnelRecordDeadlinesDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports